import React, { useState } from "react";
import {
  TableRow,
  TableCell,
  Table,
  TableBody,
  TableContainer,
  Paper,
} from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  IconButtonDatatable,
  TableHeader,
  DatatablesFooterServerSide,
  Loading,
  SearchInput,
  MasterButton,
} from "App/Component/ui";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import {
  headCells,
  RESET_STATE_DAFTAR_BARANG,
  ModalDaftarBarang,
} from "./helpers";
import { SelectIcon } from "App/Assets";
import { formatNumber } from "App/utils/helpers";
import { STYLE_DEFAULT_MASTER } from "App/constants";

export default function DaftarBarang({
  formData,
  rows,
  totalData,
  loading,
  setNewDataBarangByGudang,
  setFormFilterBarangByGudang,
  formFilterBarangByGudang,
  setNewAllData,
}) {
  const [formBarang, setFormBarang] = useState(RESET_STATE_DAFTAR_BARANG);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const classes = STYLE_DEFAULT_MASTER();
  // const [disabled, setDisabled] = useState();

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataBarangByGudang });

  const handleClickSelect = (row) => {
    setFormBarang({
      adjustment_id: formData.id,
      name: row?.namaBarang,
      qty: 1,
      barang_id: row?.barang_id,
      status_id: null,
      statuspengeluaran: "Pilih Status",
      qty_max: row.qty,
    });
    setShowModalBarang(!showModalBarang);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewDataBarangByGudang();
  };

  return (
    <>
      {showModalBarang && (
        <ModalDaftarBarang
          setShowModal={() => setShowModalBarang(false)}
          formBarang={formBarang}
          setFormBarang={setFormBarang}
          setNewAllData={setNewAllData}
        />
      )}

      <Paper
        className={classes.paper}
        style={{
          padding: "1rem",
        }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <p className='fw-600 fs-14'>Daftar Barang</p>
          <form onSubmit={(e) => handleSubmit(e)}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}>
              <div>
                <SearchInput
                  withIcon={true}
                  heightInput='0.4'
                  onchange={(e) =>
                    setFormFilterBarangByGudang({
                      ...formFilterBarangByGudang,
                      barang_name: e.target.value,
                    })
                  }
                />
              </div>
              <MasterButton type='submit' color='green' name='CARI' size='md' />
            </div>
          </form>
        </div>
        <Loading show={loading} />
        <div className='mt-1'>
          <TableDaftarBarang
            rows={rows}
            classes={classes}
            handleClickSelect={handleClickSelect}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </div>
      </Paper>
    </>
  );
}

const TableDaftarBarang = ({ rows, classes, handleClickSelect }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "namaBarang",
    orderByRow: ["namaBarang"],
  });

  return (
    <TableContainer
      className='custom-scrollbar'
      style={{
        maxHeight: "400px",
      }}>
      <Table
        className={classes.table}
        aria-labelledby='tableTitle'
        size={"medium"}
        aria-label='enhanced table'>
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  width='5%'
                  align='center'>
                  {index + 1}
                </TableCell>
                <TableCell
                  component='th'
                  scope='row'
                  width='10%'
                  padding='none'
                  align='center'>
                  <IconButtonDatatable
                    color='secondary'
                    aria-label='delete'
                    onClick={() => handleClickSelect(row)}
                    style={{
                      background: "#D8D8D8",
                      borderRadius: "8px",
                      padding: "4px",
                    }}>
                    <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                  </IconButtonDatatable>
                </TableCell>
                <TableCell align='left' width='10%'>
                  {row?.barang_id}
                </TableCell>
                <TableCell align='left'>{row?.namaBarang}</TableCell>
                <TableCell align='left' width='10%'>
                  {formatNumber(row?.qty)}
                </TableCell>{" "}
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align='center' colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
